import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { Card } from '@/components/ui';
import { cn } from '@/lib/cn';
import { Sparkline } from './charts';

/** Stat tile: one headline number, an optional decorative trend, and supporting text below. */
export function Kpi({
  label,
  value,
  hint,
  icon: Icon,
  tint,
  trend,
  children,
}: {
  label: string;
  value: ReactNode;
  hint?: string;
  icon: LucideIcon;
  tint: string;
  trend?: { values: number[]; color: string };
  children?: ReactNode;
}) {
  return (
    <Card className="group hover:shadow-card-hover relative overflow-hidden p-4 transition-shadow">
      <div className="flex items-start justify-between gap-2">
        <span className={cn('flex h-9 w-9 items-center justify-center rounded-xl ring-1 ring-inset', tint)}>
          <Icon className="h-[18px] w-[18px]" aria-hidden />
        </span>
        {trend && <Sparkline values={trend.values} color={trend.color} />}
      </div>
      <p className="mt-3 text-xs font-medium text-slate-500" title={hint}>
        {label}
      </p>
      <p className="font-heading mt-0.5 text-[26px] leading-8 font-bold text-slate-900 tabular-nums">
        {value}
      </p>
      <div className="mt-1.5">{children}</div>
    </Card>
  );
}
